import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

export class ProductNumber extends Component {
    static defaultProps = {
        productOptions: {},
    };

    static propTypes = {
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    };

    render() {
        const { productOptions } = this.props;
        let modalNumber = '';
        let webId = '';
        /* istanbul ignore next */
        if (
            productOptions &&
            Object.keys(productOptions).length &&
            productOptions.selectedProductLot.length
        ) {
            modalNumber = productOptions.selectedProductLot[0].modelNumber;
            webId = productOptions?.selectedProductLot[0]?.id;
        }
        return (
            <span className={dt(['float-right', 'sm:pb-0', 'lg:mb-4', 'lg:mt-0'])}>
                {webId} {modalNumber && modalNumber.length ? `${modalNumber}` : null}
            </span>
        );
    }
}

export default ProductNumber;
